import {combineEpics, Epic} from 'redux-observable';
import {from} from 'rxjs';
import {catchError, filter, switchMap, tap} from 'rxjs/operators';
import {refreshMenuAction, resetMenuModelsAction} from 'appmodule/home/action/MenuAction';
import {selMenuRefreshTS} from 'appmodule/home/selector/MenuSelector';
import moment from 'moment';
import {alertServerError} from 'module/ConfirmDialog/component/ConfirmDialogContainer'
import {fetchMenuAPI} from 'appmodule/home/API/MenuAPI'

let fetching = false

const RefreshMenuEpic: Epic = (action$, state$) => action$.pipe(
	filter(refreshMenuAction.match),
	filter(({payload: {force}}) => !fetching && (force || selMenuRefreshTS(state$.value) < +moment().startOf('day'))),
	switchMap(() => {
			fetching = true
			return from(fetchMenuAPI()).pipe(
				switchMap(response => [resetMenuModelsAction(response.data)]),
				tap(() => fetching = false),
				catchError((err) => {
					void alertServerError(err, "Fehler beim Laden der Menüeinträge")
					return [resetMenuModelsAction([])]
				}),
			);
		},
	),
)

export const MenuEpic = combineEpics(RefreshMenuEpic)